import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';
import get from 'lodash.get';

import { HpSharedModuleContainer } from '../HpSharedModuleContainer/HpSharedModuleContainer';
import { HpRespFeaturedModuleItem } from './HpRespFeaturedModuleItem';
import styles from './HpRespFeaturedModule.scss';
import { trackFeaturedImpressions, trackFeaturedClick } from './helpers/FeaturedTracking';
import { HpSharedInViewport } from '../HpSharedInViewport/HpSharedInViewport';

class HpRespFeaturedModuleComponent extends Component {
    featuredModule = get(this.props, 'homepage.featuredModule');

    handleInitialDisplay = ({ inViewport }) => {
        if (this.featuredModule && inViewport) {
            const { items, primaryItem } = this.featuredModule;
            trackFeaturedImpressions([primaryItem, ...items]);
        }
    };

    render() {
        if (!this.featuredModule) {
            return null;
        }

        const { items, primaryItem } = this.featuredModule;

        return (
            <HpSharedModuleContainer addTopGap>
                <HpSharedInViewport
                    stopWhenInViewport
                    onInViewportChange={this.handleInitialDisplay}
                >
                    <div className="rowFlex">
                        <div className={classnames(styles.primaryItem, 'colXs12 colLg6')}>
                            <a
                                className={styles.primaryLink}
                                href={primaryItem.link}
                                onClick={() => trackFeaturedClick(primaryItem, 0)}
                            >
                                <img className={styles.primaryImage} src={primaryItem.imageUrl} />
                            </a>
                        </div>

                        <div className={classnames(styles.productItems, 'colXs12 colLg6')}>
                            <div className="rowFlex">
                                {items.map((item, index) => (
                                    <HpRespFeaturedModuleItem
                                        key={item.cmsId}
                                        item={item}
                                        onClick={() => {
                                            /**
                                             * Index incremented by 1 because primaryItem is using `position: 1`
                                             */
                                            trackFeaturedClick(item, index + 1);
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </HpSharedInViewport>
            </HpSharedModuleContainer>
        );
    }
}

HpRespFeaturedModuleComponent.propTypes = {
    homepage: PropTypes.object.isRequired,
};

export const HpRespFeaturedModule = createFragmentContainer(HpRespFeaturedModuleComponent, {
    homepage: graphql`
        fragment HpRespFeaturedModule_homepage on Homepage {
            featuredModule: module(type: "featured") {
                ... on FeaturedModule {
                    primaryItem {
                        cta
                        link
                        imageUrl
                    }
                    items {
                        cmsId
                        cta
                        link
                        imageUrl
                        title
                    }
                }
            }
        }
    `,
});
